import axios from 'axios';
import React, { useState } from 'react'
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import InputOption from '../../component/InputOption/InputOption';

const BudgetManagement = () => {

  const navigate = useNavigate();

  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PATH_ACCOUNT = "api/erpppsu/account/cashbank";
  const PATH_BUDGET = "api/erpppsu/budget";

  const [optionBudget, setOptionBudget] = useState([]);
  const [budgetSelected, setBudgetSelected] = useState("");

  const [data, setData] = useState([]);
  const [dataAccount, setDataAccount] = useState([]);
  const [dataBudget, setDataBudget] = useState([]);
  const [detailBudget, setDetailBudget] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [nameBudget, setNameBudget] = useState("");
  const [firstPeriod, setFirstPeriod] = useState("");
  const [totalPeriod, setTotalPeriod] = useState("");
  const [beforePeriod, setBeforePeriod] = useState("");

  const [tableData, setTableData] = useState([]);
  const [headers, setHeaders] = useState([]);

  const fetchData = async (URL) => {
    try {
      const response = await axios.get(URL);
      return response.data;
    } catch (err) {
      setError("Failed to fetch data. Please try again later.");
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const generateTable = () => {
    if (dataAccount.length == 0) {
      alert("Belum ada akun yang disimpan");
      return;
    }

    const startDate = new Date(`${firstPeriod}-01`);
    const months = [];
    for (let i = 0; i < totalPeriod; i++) {
      const newDate = new Date(startDate);
      newDate.setMonth(startDate.getMonth() + i);
      months.push(newDate.toLocaleString("id-ID", { month: "long", year: "numeric" }));
    }

    const closeDate = new Date(`${firstPeriod}-01`);
    const monthsBefore = [];
    for (let i = beforePeriod; i > 0; i--) {
      const newDate = new Date(closeDate);
      newDate.setMonth(closeDate.getMonth() - i);
      monthsBefore.push(newDate.toLocaleString("id-ID", { month: "long", year: "numeric" }));
    }

    setHeaders(["Akun", ...monthsBefore, ...months, "Total"]);

    const data = dataAccount?.map(account => ({
      id_account: account.id,
      name_account: account.name,
      type_account: account.type,
      values: [...Array(monthsBefore.length).fill(0), ...Array(months.length).fill(0)],
      total: 0,
    })) || [];

    setTableData(data);
  };

  useEffect(() => {
    fetchData(`${BASE_URL}${PATH_ACCOUNT}?types=income,cost_of_goods_sold,expenses`).then((data) => {
      setDataAccount(data)
    });
    
    fetchData(`${BASE_URL}${PATH_BUDGET}/option`).then((data) => {
      setOptionBudget([{
        'id': -1,
        'name': 'new'
      }, ...data]);
    });
  }, []);

  useEffect(() => {
    if (budgetSelected) {
      fetchData(`${BASE_URL}${PATH_BUDGET}?id=${budgetSelected}`).then((data) => {
        const { name, first_period, total_period, total_period_before } = data.data;
        const { detail: budget } = data;
        setNameBudget(name)
        setFirstPeriod(first_period);
        setTotalPeriod(total_period);
        setBeforePeriod(total_period_before);
        setDetailBudget(budget);
      });
    }
  }, [budgetSelected]);

  useEffect(() => {
    if (nameBudget && firstPeriod && totalPeriod && beforePeriod && detailBudget) {
      generateTable();
    }

  }, [nameBudget, firstPeriod, totalPeriod, beforePeriod, detailBudget]);

  useEffect(() => {
    if (detailBudget.length > 0) {
      setTableData((prevTableData) => {
        const updatedTableData = prevTableData.map((row) => {
          const updatedValues = [...row.values]; // Clone the existing values array

          detailBudget.forEach((detail) => {
            const [accountId, periodIndex] = detail.key.split("_").map(Number);

            if (row.id_account == accountId && periodIndex < updatedValues.length) {
              updatedValues[periodIndex] = detail.value; // Update value for the matching period
            }
          });

          const updatedTotal = updatedValues.reduce((sum, val) => sum + parseFloat(val || 0), 0);

          console.log({
            ...row,
            values: updatedValues,
            total: updatedTotal, // Recalculate total for the row
          });



          return {
            ...row,
            values: updatedValues,
            total: updatedTotal, // Recalculate total for the row
          };
        });

        return updatedTableData;
      });
    }
  }, [detailBudget]);



  return (
    <div className="p-4">
      <h1 className="text-lg font-bold mb-4">Manajemen Anggaran</h1>

      <div className="container m-auto grid grid-cols-5 sm:grid-cols-2 xs:grid-cols-1 md:grid-cols-3 lg:grid-cols-5 my-3 gap-4">
        <div className="">
          <InputOption
            label="Pilih Anggaran"
            data={optionBudget}
            placeholder="Ketik disini"
            onChange={(value) => {
              if (value == -1) {
                navigate('/activity-erpppsu/budget-management/new');
              } else {
                setBudgetSelected(value);
              }
            }} />
        </div>
      </div>
      <div className="container m-auto grid grid-cols-5 sm:grid-cols-2 xs:grid-cols-1 md:grid-cols-3 lg:grid-cols-5 my-3 gap-4">
        <div className="">
          <label htmlFor="first_period" className="block mb-1 text-sm font-semibold">Awal Periode</label>
          <input
            id="first_period"
            name="first_period"
            type="month"
            className="my-1 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
            defaultValue={firstPeriod}
            onChange={(e) => setFirstPeriod(e.target.value)} />
        </div>

        <div className="">
          <label htmlFor="first_period" className="block mb-1 text-sm font-semibold">Jumlah Periode</label>
          <InputOption
            label="Pilih Jumlah Periode"
            data={[
              {
                'id': 1,
                'code': '',
                'name': '1 Periode',
              },
              {
                'id': 2,
                'code': '',
                'name': '2 Periode',
              },
              {
                'id': 3,
                'code': '',
                'name': '3 Periode',
              },
              {
                'id': 4,
                'code': '',
                'name': '4 Periode',
              },
              {
                'id': 6,
                'code': '',
                'name': '6 Periode',
              },
              {
                'id': 8,
                'code': '',
                'name': '8 Periode',
              },
              {
                'id': 12,
                'code': '',
                'name': '12 Periode',
              },
              {
                'id': 24,
                'code': '',
                'name': '24 Periode',
              }
            ]}
            placeholder="Ketik disini"
            onChange={(value) => setTotalPeriod(value)}
          />
        </div>

        <div className="">
          <label htmlFor="first_period" className="block mb-1 text-sm font-semibold">Periode Sebelumnya</label>
          <InputOption
            label="Pilih Periode Sebelumnya"
            data={[
              {
                'id': 3,
                'code': '',
                'name': '3 Periode Terakhir',
              },
              {
                'id': 6,
                'code': '',
                'name': '6 Periode Terakhir',
              },
              {
                'id': 12,
                'code': '',
                'name': '12 Periode Terakhir',
              }
            ]}
            placeholder="Ketik disini"
            onChange={(value) => setBeforePeriod(value)}
          />
        </div>

        {/* Filter Button */}
        {/* <div className="p-3 flex items-end">
          <button
            onClick={generateTable}
            type="button"
            className="w-full bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring focus:ring-blue-200"
          >
            Filter
          </button>
        </div> */}
      </div>

      {tableData?.length > 0 && (
        <table className="w-full border-collapse border border-gray-300">
          <thead>
            <tr>
              {headers.map((header, index) => (
                <th
                  key={index}
                  className="border border-gray-300 px-4 py-2 text-left bg-gray-100"
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {tableData.map((row, rowIndex) => (
              <tr key={rowIndex}>
                <td className="border border-gray-300 px-4 py-2">
                  {row.name_account}&nbsp;<span className='font-bold align-top text-xs'>{row.type_account}</span>
                </td>
                {row.values.map((value, periodIndex) => (
                  <td className="border border-gray-300 px-4 py-2" key={periodIndex}>
                    <input
                      disabled
                      id={`${row.id_account}_${periodIndex}`}
                      name={`${row.id_account}_${periodIndex}`}
                      type="number"
                      className="border rounded-md p-1 w-full"
                      value={value || ""}
                    />
                  </td>
                ))}
                <td className="border border-gray-300 px-4 py-2">{row.total}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default BudgetManagement;
